import { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AgeGate from "@/components/AgeGate";
import { Toaster } from "sonner";

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-[#0A0B0E] text-white">
      <AgeGate />
      <Navbar />
      <main className="pt-16 md:pt-20" data-testid="page-main">
        <Outlet />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#13161C",
            color: "#F8FAFC",
            border: "1px solid #1F242E",
          },
        }}
      />
    </div>
  );
}
